import Swiper from "swiper/bundle";
import "swiper/css/bundle";

export const initSwiper = () => {
	// Swiperのインスタンスを保持する配列
	let swiperInstances = [];

	const initServiceSwiper = () => {
		const swiperEls = document.querySelectorAll(".service-swiper");
		if (swiperEls.length === 0) return;

		// 1024px以上かどうかの判定
		const isDesktop = window.matchMedia("(min-width: 1024px)").matches;

		const swiperConfig = {
			loop: false,
			speed: 600,
			autoHeight: true,
			slidesPerView: 1.4,
			spaceBetween: 40,
			observer: true,
			observeParents: true,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 1.8,
					spaceBetween: 40,
				},
			},
		};

		if (isDesktop) {
			// --- 1024px以上：Swiperを解体する ---
			if (swiperInstances.length > 0) {
				swiperInstances.forEach((instance) => {
					if (instance) instance.destroy(true, true);
				});
				swiperInstances = []; // 配列を空にする
			}

			// ★追加：PC表示になったらアコーディオンの開きっぱなしをリセットする（推奨）
			// これをしないと、PC表示で変な余白が残ることがあります
			document.querySelectorAll(".service-card.is-open").forEach((card) => {
				card.classList.remove("is-open");
			});
		} else {
			// --- 1024px未満：Swiperを制御する ---
			if (swiperInstances.length === 0) {
				// まだSwiperがない場合は新規作成
				swiperEls.forEach((el) => {
					const newInstance = new Swiper(el, swiperConfig);
					swiperInstances.push(newInstance);
				});
			} else {
				// ★追加：すでにSwiperがある場合（リサイズ時）に強制的に高さを更新する
				// これにより「間延び」や「見切れ」を解消します
				swiperInstances.forEach((instance) => {
					instance.update(); // 全体の再計算
					instance.updateAutoHeight(0); // 高さを即座に合わせる
				});
			}
		}
	};

	// 初回実行
	window.addEventListener("load", initServiceSwiper);

	// リサイズ時に実行
	window.addEventListener("resize", initServiceSwiper);

	// ==========================================
	// 2. タブ切り替え機能
	// ==========================================
	// （ここは変更なしですが、タブ切り替え時にもSwiper更新を入れるとより安全です）
	const tabBtns = document.querySelectorAll(".service-tab-btn");
	const tabContents = document.querySelectorAll(".service-tab-content");

	tabBtns.forEach((btn) => {
		btn.addEventListener("click", () => {
			tabBtns.forEach((b) => b.classList.remove("is-active"));
			tabContents.forEach((c) => c.classList.remove("is-active"));

			btn.classList.add("is-active");

			const targetId = btn.getAttribute("data-target");
			const targetContent = document.getElementById(targetId);
			if (targetContent) {
				targetContent.classList.add("is-active");

				// ★追加：タブ切り替え時、隠れていたSwiperが表示されるので更新をかける
				if (swiperInstances.length > 0) {
					// 少し待たないとdisplay:noneからの復帰で計算がズレることがあるため
					setTimeout(() => {
						swiperInstances.forEach((instance) => {
							instance.update();
							instance.updateAutoHeight(0);
						});
					}, 100);
				}
			}
		});
	});

	// ==========================================
	// 3. アコーディオン機能（もっと詳しく見る）
	// ==========================================

	// 共通処理関数：開閉アニメーション後のSwiper更新
	const updateSwiperAfterAnimation = (card) => {
		const swiperEl = card.closest(".swiper");
		if (!swiperEl || !swiperEl.swiper) return;

		const swiperInstance = swiperEl.swiper;

		setTimeout(() => {
			swiperInstance.updateAutoHeight(400);
			swiperInstance.update();
		}, 400);
	};

	// "もっと詳しく見る" ボタン
	document.querySelectorAll(".more-btn").forEach((btn) => {
		btn.addEventListener("click", function (e) {
			e.preventDefault();
			const card = this.closest(".service-card");
			card.classList.add("is-open");
			updateSwiperAfterAnimation(card);
		});
	});

	// "閉じる" ボタン
	document.querySelectorAll(".close-btn").forEach((btn) => {
		btn.addEventListener("click", function (e) {
			e.preventDefault();
			const card = this.closest(".service-card");

			card.scrollIntoView({
				behavior: "smooth",
				block: "start",
			});

			card.classList.remove("is-open");
			updateSwiperAfterAnimation(card);
		});
	});
};
